import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, Store } from "lucide-react";
import { TERMS_TEXT, PRIVACY_TEXT } from "@/lib/legal";

export default function Legal() {
  const isPrivacy = useLocation().pathname.includes("privacy");
  const title = isPrivacy ? "Privacy Policy" : "Terms & Conditions";
  const text = isPrivacy ? PRIVACY_TEXT : TERMS_TEXT;
  return (
    <div className="min-h-screen bg-[#FAF8F5] rv-grain">
      <header className="sticky top-0 z-40 border-b border-[#E5E0D8] bg-[#FAF8F5]/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#0D5C3A] text-white"><Store className="h-4 w-4" /></div>
            <span className="font-heading font-extrabold text-[#0D5C3A]">RESTRO<span className="text-[#C85A32]">-VENDS</span></span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-1 text-sm text-stone-500 hover:text-[#0D5C3A]" data-testid="legal-home-link"><ArrowLeft className="h-4 w-4" /> Home</Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-10">
        <h1 className="font-heading text-3xl font-extrabold text-stone-900" data-testid="legal-title">{title}</h1>
        <div className="mt-6 whitespace-pre-wrap text-sm leading-relaxed text-stone-700" data-testid="legal-content">{text}</div>
      </main>
    </div>
  );
}
